import React, { useEffect, useRef, useState } from "react";
import "../../../css/Template1DarkCard.css";
import { useNavigate } from "react-router-dom";
import { unclaimOffer } from "../unclaimOffer";
import { claimOffer } from "../claimOffer";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatOfferDate } from "../../../constant/formatOfferDate";

export default function Template1DarkCard({
	data,
	previewUrl,
	clickable = true,
	distanceKm,
}) {
	const navigate = useNavigate();

	/* ===========================
	   INITIAL CLAIM STATE
	=========================== */
	const [claimed, setClaimed] = useState(() => {
		const claims = JSON.parse(localStorage.getItem("claimedOffers")) || {};

		return !!claims[data.offerId];
	});

	/* ===========================
	   TIMER STATES
	=========================== */

	const [pendingAction, setPendingAction] = useState(null); // claim | unclaim | null
	const [progress, setProgress] = useState(0);

	const timerRef = useRef(null);
	const intervalRef = useRef(null);
	useEffect(() => {
		return () => {
			clearTimeout(timerRef.current);
			clearInterval(intervalRef.current);
		};
	}, []);
	/* ===========================
	   NAVIGATION
	=========================== */
	const navigateToOfferDetails = () => {
		navigate("/offer-details", {
			state: {
				data: data,
			},
		});
	};

	const performClaim = async (mobile) => {
		const res = await claimOffer({
			offerId: data.offerId,
			shopId: data.shopId,
			mobileNo: mobile,
		});

		if (!res.success) return;

		const claims = JSON.parse(localStorage.getItem("claimedOffers")) || {};

		claims[data.offerId] = {
			status: "claimed",
			mobile,
		};

		localStorage.setItem("claimedOffers", JSON.stringify(claims));

		setClaimed(true);

		toast.success("Offer Claimed");
	};

	/* ===========================
	   CANCEL TIMER
	=========================== */

	const cancelPendingAction = () => {
		clearInterval(timerRef.current);

		setPendingAction(null);
		setProgress(0);

		toast.info("Claim cancelled");
	};

	/* ===========================
	   START 7 SECOND TIMER
	=========================== */

	const startTimer = (action, mobile) => {
		setPendingAction(action);
		setProgress(0);

		const duration = 7000;
		const start = Date.now();

		timerRef.current = setInterval(() => {
			const elapsed = Date.now() - start;

			setProgress(Math.min((elapsed / duration) * 100, 100));

			if (elapsed >= duration) {
				clearInterval(timerRef.current);

				setPendingAction(null);
				setProgress(0);

				performClaim(mobile);
			}
		}, 50);
	};

	/* ===========================
	   BUTTON CLICK
	=========================== */

	const handleClaim = () => {
		const claims = JSON.parse(localStorage.getItem("claimedOffers")) || {};

		// Already permanently claimed
		if (claims[data.offerId]) {
			toast.info("Offer already claimed. It cannot be cancelled now.");
			return;
		}

		// Timer already running
		if (pendingAction) return;

		const mobile = prompt("Enter mobile number");

		if (!mobile) return;

		startTimer("claim", mobile);
	};

	return (
		<div className="t1-card my-3">
			<ToastContainer
				position="top-right"
				autoClose={3000}
				hideProgressBar={false}
				closeOnClick
				pauseOnHover
				theme="light"
			/>
			<div
				className="t1-image"
				onClick={(e) => {
					e.stopPropagation();
					navigateToOfferDetails();
				}}
			>
				<img src={data.image || previewUrl} alt="" />

				{data.offerValue &&
				(data.offerType.toLowerCase() === "flat" ||
					data.offerType.toLowerCase() === "percent") ? (
					<span className="discount-badge">
						{data.offerType.toLowerCase() === "flat" && (
							<span>Rs. {data.offerValue} OFF</span>
						)}

						{data.offerType.toLowerCase() === "percent" && (
							<span>{data.offerValue}% OFF</span>
						)}
					</span>
				) : (
					<div className="d-flex discount-badge">
						{data.offerType || "❤️"}
					</div>
				)}
			</div>

			<div className="t1-body mt-2">
				<h4>{data.title}</h4>

				<p>{data.description}</p>

				<small className="start-end-date">
					<span className="pr-1">📅</span>
					{data.startDate
						? `Valid:  ${formatOfferDate(data.startDate)} - ${formatOfferDate(data.endDate)}`
						: `Valid: - ${formatOfferDate(data.endDate)}`}
				</small>

				<div className="t1-footer justify-content-between">
					{(data.originalPrice || data.discountedPrice) && (
						<div>
							<div className="discounted-price">
								<span>Rs.{data.discountedPrice}</span>
							</div>

							<div className="original-price">
								<span>Rs.{data.originalPrice}</span>
							</div>
						</div>
					)}
					{pendingAction && (
						<div className="claim-progress-wrapper mt-2">
							<div className="justify-content-between align-items-center mb-3">
								<span>
									{pendingAction === "claim"
										? "Claiming offer..."
										: "Removing claim..."}
								</span>
								<br />
								<span>Tap button to cancel</span>
							</div>

							<div className="claim-progress-bg">
								<div
									className="claim-progress-fill"
									style={{
										width: `${progress}%`,
									}}
								/>
							</div>
						</div>
					)}

					<div className="justify-content-end">
						<button
							onClick={(e) => {
								e.stopPropagation();

								if (pendingAction) {
									cancelPendingAction();
									return;
								}
								if (claimed) {
									toast.info(
										"Offer already claimed. It cannot be unclaimed.",
									);
									return;
								}
								handleClaim();
							}}
							className={
								pendingAction
									? "claim-btn cancel-btn"
									: claimed
										? "claim-btn claimed-btn"
										: "claim-btn"
							}
						>
							{pendingAction
								? "Cancel Claim"
								: claimed
									? "Claimed"
									: "Claim Offer"}
						</button>
					</div>
				</div>
				{/* <div className="text-left pt-3 calculated-distance">
					<i class="fa-solid fa-location-arrow pr-2"></i>
					<span>{data.calculatedDistance} km</span>
				</div> */}
			</div>
		</div>
	);
}
